import { memo } from 'react';

import { Flex, Typography } from 'antd';

import ButtonLink from '../../views/ui-components/ButtonLink';

import styles from './styles.module.scss';

import logo from '../../assets/images/Kraal-Full-Colour-stacked.webp';

const { Title } = Typography;

const Error403 = () => {
  return (
    <Flex vertical={true} align="center" justify="center" className={styles['error-403']}>
      <img src={logo} alt="Kraal logo" height="185" width="260" />
      <Title level={1} className={styles['error-title']}>
        Sorry, access denied
      </Title>
      <Title level={5} className="d-block mb-4" type="secondary">
        You don&#39;t have permission to view this page.
      </Title>
      <ButtonLink to="/profile?tab=billing&plan=true" size="large" variant="solid">
        Update subscription plan
      </ButtonLink>
    </Flex>
  );
};

export default memo(Error403);
